import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const problems = [{
  tag: '😩 Problema n. 1',
  title: '“Mi annoio!” — ancora e ancora',
  text: 'Anche con una stanza piena di giocattoli. Anche subito dopo aver comprato qualcosa di nuovo. Il ciclo della noia non finisce mai e tu stai esaurendo le idee.',
  img: 'https://cdn.magicpatterns.com/uploads/ihjE7DKY1ufhoEJhsEe429/IMG_1064.webp',
  alt: 'Bambino piccolo che piange accanto ai giocattoli',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}, {
  tag: '📱 Problema n. 2',
  title: 'Schermi. Tutto il giorno. Ogni giorno.',
  text: 'Gli dai un tablet “solo per un minuto” e due ore dopo sono ancora incollati. Niente li cattura come uno schermo — e tu lo detesti.',
  img: 'https://cdn.magicpatterns.com/uploads/iF8QAP4AAhfEAASdSCwhT5/IMG_1063.webp',
  alt: 'Bambino frustrato che fissa un tablet',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '😤 Problema n. 3',
  title: 'Hai provato di tutto — niente funziona',
  text: 'Kit creativi, puzzle, attività all’aperto… durano un pomeriggio. Continui a spendere soldi ed energie, eppure niente cattura la loro attenzione per più di un giorno.',
  img: 'https://cdn.magicpatterns.com/uploads/wLtfrSPqS9mi15yuLtP3pw/IMG_1062.webp',
  alt: 'Due ragazzi nascosti dietro i loro telefoni',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '😭 Problema n. 4',
  title: 'La crisi quando lo schermo viene tolto',
  text: 'Ogni volta che limiti il tempo davanti allo schermo, diventa una battaglia. Lacrime, capricci, trattative. Ti senti il cattivo, anche se vuoi solo il meglio per loro.',
  img: 'https://cdn.magicpatterns.com/uploads/by9pMNhj1jGZXhdizermvD/IMG_1065.webp',
  alt: 'Bambina che piange accanto a un orsacchiotto',
  tone: 'bg-brand-light',
  tagTone: 'bg-brand/15 text-brand'
}];
export function Problems() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-145" data-mp="owi0xw1tdhyh">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-146" data-mp="kvy5qy0swoez">
        <SectionHeading eyebrow="Ti suona familiare?" title="Conosci questa sensazione?" subtitle="Ogni genitore la conosce. Vuoi che i tuoi figli si allontanino dagli schermi e si dedichino a qualcosa di concreto — ma niente sembra catturare la loro attenzione a lungo." data-id="element-147" data-mp="kwfyvls62mio" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-148" data-mp="5zyr14j6rq0v">
          {problems.map((p, i) => <motion.article key={p.tag} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${p.tone}`} data-id="element-149" data-mp="16ntju09kllm" data-mpi={i}>
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-150" data-mp="398lmyma3yq9v">
                <img src={p.img} alt={p.alt} className="h-full w-full object-cover" data-id="element-151" data-mp="3e8zqps4ofe23" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-152" data-mp="3j5glv6aamsoo">
                <span className={`mb-3 w-fit rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${p.tagTone}`} data-id="element-153" data-mp="2lldk0b05jtb0">
                  {p.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-154" data-mp="2vhp2xju8zhef">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-155" data-mp="309qknla6q0bu">
                  {p.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}